@use "Styles/includes/variables";
@use "Styles/mixins";

:host {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 248px;
    padding: 4px 0;
    border-radius: 8px;
    background: mixins.get-color(bg, solid, primary);
    box-shadow:
        0 -1px 16px -4px rgba(10, 13, 18, 0.08),
        0 -4px 6px -2px rgba(10, 13, 18, 0.03),
        0 2px 2px -1px rgba(10, 13, 18, 0.04);
}
